import React from "react";
import { useNavigate } from "react-router-dom";
import { ResetPasswordFlow } from "../components/ResetPasswordFlow";
import { ROUTES } from "../../../shared/utils";

export const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  return <ResetPasswordFlow onBackToLogin={() => navigate(ROUTES.LOGIN)} />;
};
